import { createAction } from '@reduxjs/toolkit';
import { SearchFilterTag, Tags } from '../../../../../../common/tag/tag.types';
import constants from '../search-filter.constants';

export const applySearchFilterTags = (searchFilterName: string) => createAction<Tags>(`${searchFilterName}_${constants.APPLY_SEARCH_FILTER_TAGS}`);
export const setSearchFilterTags = (searchFilterName: string) => createAction<SearchFilterTag[]>(`${searchFilterName}_${constants.SET_SEARCH_FILTER_TAGS}`);

export const setInputModalVisibility = (searchFilterName: string) => createAction<boolean>(`${searchFilterName}_${constants.SET_INPUT_MODAL_VISIBILITY}`);
export const applyCustomSearchText = (searchFilterName: string) => createAction<string>(`${searchFilterName}_${constants.APPLY_CUSTOM_SEARCH_TEXT}`);;